"use strict";
var Coveo = require("coveo-search-ui");
var Utilities_1 = require("../Utilities");
var EndpointCaller_1 = require("../EndpointCaller");
var SitecoreAnalyticsHandler = (function () {
    function SitecoreAnalyticsHandler(options, endpointCaller) {
        this.options = options;
        this.endpointCaller = endpointCaller || new EndpointCaller_1.default();
    }
    SitecoreAnalyticsHandler.prototype.registerSitecoreAnalytics = function (domElement, windowReference) {
        var _this = this;
        (windowReference || window).onbeforeunload = function () {
            Coveo.Defer.flush();
        };
        domElement.on(Coveo.AnalyticsEvents.searchEvent, function (e, args) {
            _this.postAnalytics("searches", "searchEvents", args.searchEvents);
        });
        domElement.on(Coveo.AnalyticsEvents.documentViewEvent, function (e, args) {
            _this.postAnalytics("documentViews", "documentViewEvents", args.documentViewEvent);
        });
        domElement.on(Coveo.AnalyticsEvents.customEvent, function (e, args) {
            _this.postAnalytics("custom", "customEvents", args.customEvent);
        });
    };
    SitecoreAnalyticsHandler.prototype.postAnalytics = function (eventAction, eventType, eventData) {
        var _this = this;
        var parsedEventData = [];
        if (typeof (eventData) !== "undefined") {
            parsedEventData = parsedEventData.concat(eventData);
        }
        parsedEventData.filter(function (data) {
            return typeof (data) !== "undefined";
        }).forEach(function (data) {
            data.sitecoreItemId = _this.options.sitecoreItemId;
        });
        var postData = {};
        postData[eventType] = JSON.stringify(parsedEventData);
        this.endpointCaller.sendPost(Utilities_1.default.appendTrailingSlash(this.options.analyticsEndpointUri) + eventAction, postData);
    };
    return SitecoreAnalyticsHandler;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SitecoreAnalyticsHandler;



//////////////////
// WEBPACK FOOTER
// ./Base/Analytics/SitecoreAnalyticsHandler.js
// module id = 14
// module chunks = 0